import { gql } from '@apollo/client';
export const countFolderPickerEntriesQuery = gql `
  query countFolderPickerEntries($parentId: ID!) {
    count: countFileSystemEntries(where: { parentId: { eq: $parentId }, kind: { neq: GUIDANCE } })
  }
`;
